/* BeautyKart PDP · gallery, variants, quantity, ATC */
(function () {
  'use strict';

  // Shopify variant.price is in CENTS (integer). Convert to dollars for display.
  function money(cents) {
    var f = window.BK_MONEY_FORMATTER;
    if (typeof f === 'function') return f(cents);
    var n = Number(cents);
    if (!isFinite(n)) n = 0;
    return '$' + (n / 100).toFixed(2) + ' CAD';
  }

  function getVariants(form) {
    var node = document.querySelector('[data-bk-product-variants]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  // Update PDP UI when a variant is selected
  function applyVariant(form, variant) {
    if (!variant) return;

    var select = form.querySelector('[data-variant-select]');
    if (select) select.value = variant.id;

    var priceEl = document.querySelector('[data-price]');
    var compEl = document.querySelector('[data-compare]');
    var atcPriceEl = document.querySelector('[data-atc-price]');
    var atc = document.querySelector('[data-atc]');
    var priceNum = parseFloat(variant.price);
    var compareNum = variant.compare_at_price ? parseFloat(variant.compare_at_price) : 0;

    if (priceEl) priceEl.textContent = money(priceNum);
    if (atcPriceEl) atcPriceEl.textContent = money(priceNum);
    if (compEl) {
      if (compareNum > priceNum) {
        compEl.textContent = money(compareNum);
        compEl.style.display = '';
      } else {
        compEl.style.display = 'none';
      }
    }
    if (atc) {
      atc.disabled = !variant.available;
      var label = atc.querySelector('[data-atc-label]');
      if (label) {
        if (!variant.available) {
          label.textContent = 'Sold Out';
        } else {
          label.innerHTML = 'Add to Cart · <span data-atc-price>' + money(priceNum) + '</span>';
        }
      }
    }

    // Swap featured image if variant has one
    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = document.querySelector('.bk-pdp__slide.is-active img');
      if (mainImg) mainImg.src = variant.featured_image.src.replace(/\?.*$/, '') + '?width=1200';
    }

    // Sync hidden weight input to this variant's weight option if any
    var hiddenWeight = form.querySelector('[data-opt-hidden]');
    if (hiddenWeight) {
      var idx = parseInt(hiddenWeight.dataset.optIndex, 10);
      if (variant.options && variant.options[idx]) {
        hiddenWeight.value = variant.options[idx];
      }
    }
  }

  // Find matching variant based on currently-selected VISIBLE option values
  // Weight/hidden option is auto-selected: pick the first variant whose visible options match.
  function findVariant(form) {
    var variants = getVariants(form);
    if (!variants || !variants.length) return null;

    // Collect user-visible selections (Size etc.), keyed by option index (0-based).
    var visibleByIndex = {};
    form.querySelectorAll('.bk-pdp__swatch input[type="radio"]:checked').forEach(function (r) {
      var idx = parseInt(r.dataset.optIndex, 10);
      if (!isNaN(idx)) visibleByIndex[idx] = r.value;
    });

    // First variant whose options[i] === visibleByIndex[i] for each visible i wins.
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      Object.keys(visibleByIndex).forEach(function (idxStr) {
        var idx = parseInt(idxStr, 10);
        var wanted = visibleByIndex[idxStr];
        var got = v.options && v.options[idx];
        if (String(got) !== String(wanted)) ok = false;
      });
      if (ok) return v;
    }
    return null;
  }

  // ===== Gallery =====
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.bk-pdp__thumb, .bk-pdp__slide');
    if (thumb) {
      var idx = thumb.dataset.idx;
      if (idx == null) return;
      var wrap = thumb.closest('.bk-pdp__gallery');
      if (!wrap) return;
      wrap.querySelectorAll('.bk-pdp__slide').forEach(function (s, i) {
        s.classList.toggle('is-active', String(i) === String(idx));
      });
      wrap.querySelectorAll('.bk-pdp__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', String(i) === String(idx));
      });
      return;
    }

    // Accordion
    var accHead = e.target.closest('.bk-pdp__acc-head');
    if (accHead) {
      var item = accHead.closest('.bk-pdp__acc-item');
      item.classList.toggle('is-open');
      accHead.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      return;
    }

    // Quantity buttons
    var qtyBtn = e.target.closest('.bk-pdp__qty [data-qty]');
    if (qtyBtn) {
      var qwrap = qtyBtn.closest('.bk-pdp__qty');
      var input = qwrap.querySelector('input');
      var val = parseInt(input.value || '1', 10);
      var next = qtyBtn.dataset.qty === 'inc' ? Math.min(99, val + 1) : Math.max(1, val - 1);
      input.value = next;
      input.dispatchEvent(new Event('change'));
      return;
    }
  });

  // ===== Variant selection =====
  document.addEventListener('change', function (e) {
    var swatch = e.target.closest('.bk-pdp__swatch input[type="radio"]');
    if (!swatch) return;

    var group = swatch.closest('.bk-pdp__option-values');
    if (group) {
      group.querySelectorAll('.bk-pdp__swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.closest('.bk-pdp__swatch').classList.add('is-active');
    }

    var head = swatch.closest('.bk-pdp__option').querySelector('.bk-pdp__option-value');
    if (head) head.textContent = swatch.value;

    var form = swatch.closest('form');
    if (!form) return;

    var variant = findVariant(form);
    applyVariant(form, variant);
  });

  // ===== ATC via fetch =====
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.bk-pdp__form');
    if (!form) return;
    var atc = form.querySelector('[data-atc]');
    if (!atc) return;
    e.preventDefault();
    if (atc.disabled) return;

    // Guarantee the freshest variant id is on the form BEFORE submit.
    var variant = findVariant(form);
    if (variant) {
      var select = form.querySelector('[data-variant-select]');
      if (select) select.value = variant.id;
    }

    var buyNow = e.submitter && e.submitter.hasAttribute('data-buynow');
    var label = atc.querySelector('[data-atc-label]');
    var original = label ? label.innerHTML : atc.textContent;
    if (label) label.textContent = buyNow ? 'Preparing checkout…' : 'Adding…';
    atc.disabled = true;

    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          atc.disabled = false;
          if (label) label.textContent = 'Try again';
          setTimeout(function () { if (label) label.innerHTML = original; }, 1600);
          return;
        }
        if (buyNow) { window.location.href = '/checkout'; return; }
        atc.classList.add('is-added');
        if (label) label.textContent = '✓ Added to Cart';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        var drawerTrigger = document.querySelector('[ref="cartDrawerButton"], cart-icon, [data-cart-drawer-open], .header__cart, a[href="/cart"]');
        if (drawerTrigger) drawerTrigger.click();
        setTimeout(function () {
          atc.disabled = false;
          atc.classList.remove('is-added');
          if (label) label.innerHTML = original;
        }, 2200);
      })
      .catch(function () {
        atc.disabled = false;
        if (label) label.textContent = 'Try again';
        setTimeout(function () { if (label) label.innerHTML = original; }, 1800);
      });
  });
})();
